function InfiniteScroll() {
    this.ajax = new Ajax();
}
InfiniteScroll.prototype.initLoadMore = function (className) {
    window.ias = jQuery.ias({
        container: '.' + className,
        item: '.grid__item',
        pagination: '.' + className + ' .pagination',
        next: '.next a'
    });
    
		window.iasTrigger = new IASTriggerExtension({
            html: '<div class="ias_trigger" style=""><a>' + 'Load more' + '</a></div>'
        })
        window.ias.extension(window.iasTrigger);
    
    window.ias.extension(new IASSpinnerExtension({}));
    var itemLength = 0;
    window.ias.on('render', function () {
        itemLength = $(".nt-des-top").length;
    })
    window.ias.on('rendered', function (items) {
        var imageShopify = new ImageShopify();
        imageShopify.initImageConfigure(items);
        var countDownShopify = new CountDownShopify();
        countDownShopify.initAll(items);
        var cart = new Cart();
        cart.initAddToCart(items);
        var currentClassName = $(".nt-product-grid");
        setTimeout(function () {
            if(currentClassName === 'nt-product-grid'){
                imageShopify.initSetProductHeightLoadMore(itemLength - 1);
            }else{
                imageShopify.initSetProductHeight();
            }
        }, 420);
    })
}